import React from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { LoginForm } from "../components/LoginForm";
import { getMe } from "../api/auth";
import { qk } from "../../../lib";

export const Login: React.FC = () => {
  const navigate = useNavigate();

  const { data: session } = useQuery({
    queryKey: qk.me(),
    queryFn: getMe,
  });

  if (session?.authenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  const handleLoginSuccess = () => {
    navigate("/dashboard");
  };

  return (
    <LoginForm onSuccess={handleLoginSuccess} />
  );
};
